import { render, staticRenderFns } from "./DefaultDashboard.vue?vue&type=template&id=e9b81a56"
import script from "./DefaultDashboard.vue?vue&type=script&lang=js"
export * from "./DefaultDashboard.vue?vue&type=script&lang=js"
import style0 from "./DefaultDashboard.vue?vue&type=style&index=0&id=e9b81a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports